<template>
<div>
    <div class="row">
        <div class="col-md-12">
            <base-crud :ref="'rolesCrud'" crudName="Papéis" newText="Novo Papel" :table="table" :columns="columns" :options="options" :endPoint="endPoint" :enableAdd="true" :enableEdit="true" :enableDelete="true" :enableView="false" :enableReset="false" :dataForm="dataForm">
            </base-crud>
        </div>
    </div>
</div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
    data: function () {
        return {
            table: "rolesTable",
            columns: [
                "id",
                "name",
                "company_id",
                "status",
                "actions",
            ],
            tableData: ["id", "name", "company_id", "status"],
            optionsOrigin: {
                filterByColumn: true,
                debounce: 1000,
                filterable: ["name", "status"],
                pagination: {
                    chunk: 10,
                    dropdown: false,
                    nav: "scroll"
                },
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                listColumns: {
                    status: [
                        {id: 1, text: this.$t('Active')},
                        {id: 0, text: this.$t('Inactive')}
                    ]
                },
                templates: {
                    company_id: function (h, row) {
                        return row.company_id
                            ? (row.company ? row.company.name : 'Empresa')
                            : 'Universal (todas as empresas)';
                    },
                    status: function (h, row) {
                        return row.status == 1 ?
                            this.$t('Active') :
                            this.$t('Inactive')
                    },
                },
                requestFunction: function (data) {
                    let requestData = {};
                    let query = this.$parent.$parent.$parent.query(data.query);
                    requestData.params = data;
                    requestData.params.query = "";
                    requestData.params.with = ["company"];

                    return axios.get(this.url + "?" + query, requestData).catch(
                        function (e) {
                            this.dispatch("error", e);
                        }.bind(this)
                    );
                },
            },
            endPoint: "roles",
            dataForm: {},
        };
    },
    components: {
        BaseCrud,
    },
    computed: {
        options() {
            const headings = {
                id: this.$t('id'),
                name: 'Papel',
                company_id: 'Abrangência',
                status: this.$t('Status'),
                actions: this.$t('action'),
            }

            const texts = {
                filterBy: this.$t('Filter'),
                defaultOption: this.$t('Select'),
            }
            return {
                ...this.optionsOrigin,
                texts,
                headings,
            }
        }
    },
    methods: {
        query: function (query) {
            let columns = {
                id: "id",
                name: "name",
                status: "status"
            };
            let filters = "";
            $.each(query, function (index, value) {
                filters += columns[index] + "=" + value + "&";
            });
            return filters;
        },
    },
};
</script>

<style scoped>
.VuePagination {
    text-align: center;
}
</style>
